import styled from 'styled-components';
import { colorTelusPurple } from '@tds/core-colours/dist/index.cjs';

export const Heading = styled.p`
  padding: 12px 0;
  font-size: 24px;
  color: ${colorTelusPurple};
`;

export const Text = styled.p`
  font-weight: ${props => (props.bold ? '600' : props.fontWeight || '400')};
  font-size: 16px;
  display: inline;
  letter-spacing: -0.2px;
  color: ${props => props.color};
`;

export const customStyles = `
  overflow: scroll;
  max-height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  `;
